import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import {
    CreateCompanyWorkShift,
    UpdateWorkShiftName,
} from '../../../../../reduxToolkit/CompanyWorkShift/CompanyWorkShiftApi';
import CustomModal from '../../../../../components/Modal/CustomModal';
import { CustomTextField } from '../../../../../components/CustomTextField';
import { errorMsg } from '../../../../../Apis/functions';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const AddWorkShift = ({ show, onHide, setModified, data }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [workshiftName, setWorkShiftName] = useState(data?.name || '');
    const [emptyFields, setEmptyFields] = useState({});

    const resetForm = () => {
        setEmptyFields({});
        setWorkShiftName('');
    };

    const handleNameChange = (e) => {
        const value = e.target.value;
        setWorkShiftName(value);
    };

    useEffect(() => {
        if (data?.name) {
            setWorkShiftName(data.name);
        }
    }, [data]);

    const handleSubmit = () => {
        const isNameEmpty = workshiftName.trim() === '';
        setEmptyFields({
            name: isNameEmpty,
        });

        if (isNameEmpty) return;

        if (data?.id) {
            const payload = {
                id: data?.id,
                name: workshiftName,
            };

            dispatch(UpdateWorkShiftName(payload)).then(({payload: {data: {success, code}}}) => {
                if (success) {
                    setWorkShiftName('');
                    toast.success(t('has_been_updated_successfully'));
                    setModified(true);
                    onHide();

                } else errorMsg(code);
            });
        } else {
            dispatch(CreateCompanyWorkShift(workshiftName)).then(() => {
                setWorkShiftName('');
                setModified(true);
                onHide();
            });
        }
    };

    return (
        <CustomModal
            show={show}
            onHide={() => {
                onHide();
                resetForm();
            }}
            onConfirm={handleSubmit}
            title={ data?.id ? 'change_name' : 'add_new_work_shift'}
            buttonConfirm={ data?.id ? 'update' : 'create'}
        >
            <div>
                <div className='mt-3'>
                    <CustomTextField
                        id='txt_aws_name'
                        trans='name'
                        onChange={handleNameChange}
                        value={workshiftName}
                        isRequired={true}
                        emptyFields={emptyFields.name}
                    />
                </div>
            </div>
        </CustomModal>
    );
};

export default AddWorkShift;
